// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-colorpip {
  width: 32px;
  height: 32px;
  padding: 8px 8px;
}
.bolt-colorpip:focus {
  outline: none;
}
.bolt-colorpip:focus .bolt-colorpip-content {
  box-shadow: 0 0 0 2px rgba( 255, 255, 255 ,  1 ), 0 0 0 5px rgba( 234, 234, 234 ,  1 );
  box-shadow: 0 0 0 2px rgba( var(--palette-neutral-0,255, 255, 255) ,  1 ), 0 0 0 5px rgba( var(--palette-neutral-8,234, 234, 234) ,  1 );
}
.bolt-colorpip .bolt-colorpip-content {
  width: 16px;
  height: 16px;
  border-radius: 10px;
  box-shadow: 0 0 0 2px rgba( 255, 255, 255 ,  1 );
  box-shadow: 0 0 0 2px rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
}
.bolt-colorpip .bolt-colorpip-content.selected, .bolt-colorpip .bolt-colorpip-content.selected:focus {
  box-shadow: 0 0 0 2px rgba( 255, 255, 255 ,  1 ), 0 0 0 5px rgba(0, 120, 215, 0.24);
  box-shadow: 0 0 0 2px rgba( var(--palette-neutral-0,255, 255, 255) ,  1 ), 0 0 0 5px rgba(0, 120, 215, 0.24);
}

/*# sourceMappingURL=ColorPip.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/ColorPip/ColorPip.scss","webpack://./../azure-devops-ui/bin/Components/ColorPip/ColorPip.css"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;ACAJ;ADEI;EACI,aAAA;ACAR;ADEQ;EACI,sFAAA;ECAV,wIAAwI;ADItI;ACFJ;EDIQ,WAAA;EAEA,YAAA;EAEA,mBAAA;ECJN,gDAAgD;EDO1C,yEAAA;ACLR;AACA;EACE,mFAAmF;EACnF,4GAA4G;AAC9G;;AAEA,uCAAuC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
